// // // // pages/CorporatePage.jsx
// // // import React from "react";
// // // import { Link } from "react-router-dom";
// // // import CorporateSidebar from "../components/Corporate/CorporateSidebar";
// // // import AboutSection from "../components/Corporate/AboutSection";
// // // import HeroSlider from "../components/HeroSlider";
// // // import Footer from "../components/Footer";

// // // const CorporatePage = () => {
  

// // //   return (
// // //     <>
// // //       {/* Hero slider üstte */}
// // //       <HeroSlider />

// // //       {/* Sayfa içeriği */}
// // //       <div className="bg-white text-black py-8 px-4 max-w-screen-xl mx-auto">
// // //         <div className="text-sm text-gray-600 mb-4">
// // //           <Link to="/" className="underline">ana sayfa</Link> &nbsp;>&nbsp; <Link to="/kurumsal" className="underline">kurumsal</Link>
// // //         </div>

// // //         <div className="text-xl font-semibold text-[#003132] mb-6">KURUMSAL MENÜ</div>

// // //         <div className="flex flex-col md:flex-row gap-10">
// // //           <CorporateSidebar />
// // //           <AboutSection />
// // //         </div>
// // //       </div>
// // //       <Footer />
// // //     </>
// // //   );
// // // };

// // // export default CorporatePage;
// // import React from "react";
// // import { Link } from "react-router-dom";
// // import CorporateSidebar from "../components/Corporate/CorporateSidebar";
// // import AboutSection from "../components/Corporate/AboutSection";
// // import HeroSlider from "../components/HeroSlider";
// // import Footer from "../components/Footer";

// // const CorporatePage = () => {
// //   return (
// //     <>
// //       {/* Hero slider üstte */}
// //       <HeroSlider />

// //       {/* Sayfa içeriği */}
// //       <div className="bg-white text-black py-8 px-4 max-w-screen-xl mx-auto">
        
// //         {/* Breadcrumb (Konum belirteci) */}
// //         <div className="text-sm text-gray-600 mb-4">
// //           <Link to="/" className="underline">Ana Sayfa</Link> &nbsp;>&nbsp;
// //           <Link to="/kurumsal" className="underline">Kurumsal</Link>
// //         </div>

// //         {/* Başlık */}
// //         <div className="text-xl font-semibold text-[#003132] mb-6">KURUMSAL MENÜ</div>

// //         {/* Sayfa içeriği ve sidebar */}
// //         <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
// //           {/* Sidebar (Sol Menü) */}
// //           <div className="md:col-span-4">
// //             <CorporateSidebar />
// //           </div>

// //           {/* İçerik (Sağ Kısım) */}
// //           <div className="md:col-span-8">
// //             <AboutSection />
// //           </div>
// //         </div>
// //       </div>

// //       {/* Footer */}
// //       <Footer />
// //     </>
// //   );
// // };

// // export default CorporatePage;
// import React from "react";
// import { Link } from "react-router-dom";
// import CorporateSidebar from "../components/Corporate/CorporateSidebar";
// import AboutSection from "../components/Corporate/AboutSection";
// import HeroSlider from "../components/HeroSlider";
// import Footer from "../components/Footer";

// const CorporatePage = () => {
//   return (
//     <>
//       {/* Hero slider üstte */}
//       <HeroSlider />

//       {/* Sayfa içeriği */}
//       <div className="bg-white text-black py-8 px-4 max-w-screen-xl mx-auto">
        
//         {/* Breadcrumb (Konum belirteci) */}
//         {/* <div className="text-sm text-gray-600 mb-4">
//           <Link to="/" className="underline">Ana Sayfa</Link> &nbsp;>&nbsp;
//           <Link to="/kurumsal" className="underline">Kurumsal</Link>
//         </div> */}

//         {/* Başlık */}
//         <div className="text-xl font-semibold text-[#003132] mb-6">KURUMSAL MENÜ</div>

//         {/* Sayfa içeriği ve sidebar */}
//         <div className="flex flex-col md:flex-row gap-6">
//           {/* Sidebar (Sol Menü) */}
//           <div className="w-full md:w-1/4">
//             <CorporateSidebar />
//           </div>

//           {/* İçerik (Sağ Kısım) */}
//           <div className="w-full md:w-3/4">
//             <AboutSection />
//           </div>
//         </div>
//       </div>

//       {/* Footer */}
//       <Footer />
//     </>
//   );
// };

// export default CorporatePage;
import React from "react";
// import { Link } from "react-router-dom";
import CorporateSidebar from "../components/Corporate/CorporateSidebar";
import AboutSection from "../components/Corporate/AboutSection";
import HeroSlider from "../components/HeroSlider";
import Footer from "../components/Footer";

const CorporatePage = () => {
  return (
    <>
      {/* Hero slider üstte */}
      <HeroSlider />

      {/* Sayfa içeriği */}
      <div className="bg-white text-black py-8 px-4 max-w-screen-xl mx-auto">
        
        {/* Breadcrumb (Konum belirteci) */}
        {/* <div className="text-sm text-gray-600 mb-4">
          <Link to="/" className="underline">Ana Sayfa</Link> &nbsp;>&nbsp;
          <Link to="/kurumsal" className="underline">Kurumsal</Link>
        </div> */}

        {/* Başlık */}
        <div className="text-xl font-semibold text-[#003132] mb-6">KURUMSAL MENÜ</div>

        {/* Sayfa içeriği ve sidebar */}
        <div className="grid grid-cols-1 md:grid-cols-12 gap-6">
          {/* Sidebar (Sol Menü) */}
          <div className="md:col-span-4 flex-shrink-0">
            <CorporateSidebar />
          </div>

          {/* İçerik (Sağ Kısım) */}
          <div className="md:col-span-8 max-w-3xl overflow-auto">
            <AboutSection />
          </div>
        </div>
      </div>

      {/* Footer */}
      <Footer />
    </>
  );
};

export default CorporatePage;
